/* Quantity stepper (snippets/quick-add-qty.liquid): the collection table rows and the quick-add drawer. Loaded on every page from
   snippets/head.liquid because the drawer opens from any page with product cards, and scripts inside injected markup never run.
   Delegated on the document, so injected markup works. */
(function () {
  function clampQuantity(input) {
    var value = parseInt(input.value, 10);
    input.value = isNaN(value) || value < 1 ? 1 : value;
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.closest('[data-qty]').querySelector('input');
    input.value = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
    clampQuantity(input);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.quick-add__qty-input')) clampQuantity(event.target);
  });

  /* Enter in the quantity field would submit the form natively (a page load on /cart/add); press the add button instead */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('.quick-add__qty-input')) return;
    event.preventDefault();
    clampQuantity(event.target);
    var add = event.target.form && event.target.form.querySelector('[data-add-to-cart]');
    if (add) add.click();
  });
})();
